import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorMessage from '../alerts/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import TwoFactorRecoveryDao from '../../data/TwoFactorRecoveryDao';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoFactorNametagRecoveryForm = ({
  stopNametagRecovery,
  token
}) => {
  const history = useHistory();
  const [error, setError] = useState('');
  const [nametagPollingInterval, setNametagPollingInterval] = useState();
  const [intervalShouldRun, setIntervalShouldRun] = useState(true);
  const onPrevPage = () => {
    stopNametagRecovery();
  };
  useEffect(() => {
    if (!nametagPollingInterval && intervalShouldRun) {
      setNametagPollingInterval(setInterval(handleNametagInterval, 1000));
    }
    function handleNametagInterval() {
      TwoFactorRecoveryDao.nameTagPolling(token).then(value => {
        if (value) {
          setTimeout(() => {
            history.replace({
              pathname: '/',
              search: `?authFailureReason=two_factor_recovered`
            });
          }, 15000);
        }
      }).catch(() => {
        setError('TWO_FACTOR_NAMETAG_FAILED');
        setIntervalShouldRun(false);
        clearTimeout(nametagPollingInterval);
      });
    }
    return () => {
      if (nametagPollingInterval) {
        clearTimeout(nametagPollingInterval);
      }
    };
  }, [nametagPollingInterval, intervalShouldRun, token, history]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        as: "h1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.twoFactor.recoveryNameTag.success"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.twoFactor.recoveryNameTag.successBody"
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        error: error,
        details: {
          onPrevPage
        }
      })]
    })
  });
};
export default TwoFactorNametagRecoveryForm;